(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller('SchedulePremiumsModalController', SchedulePremiumsModal);

    SchedulePremiumsModal.$inject = ['$scope', '$q', '$filter', 'modalData', 'fairSchedulingService', 'TeamScheduleService', 'TSUsersService', 'ScheduleDataServiceV2', 'onSave', 'onDelete', 'onRestore'];

    function SchedulePremiumsModal ($scope, $q, $filter, modalData, fairSchedulingService, TeamScheduleService, TSUsersService, ScheduleDataServiceV2, onSave, onDelete, onRestore) {
        var self = this;

        self.activeScheduleView = modalData.activeScheduleView;
        self.startDayOfWeek = modalData.startDate;
        self.PREMIUM_TYPES = fairSchedulingService.SHIFT_PENALTY_CHANGE_TYPES;

        self.filters = modalData.filters? angular.copy(modalData.filters): {};
        self.users = TSUsersService.users;
        self.isRequestedByAssigneeOptions = [
            {key: 'YES', value: $filter("translate")('Yes')},
            {key: 'NO', value: $filter("translate")('No')},
        ];

        self.consentStatusOptions = [
            {
                key: 'PENDING_EMPLOYEE_APPROVAL',
                value: $filter("translate")('Pending')
            },
            {
                key: 'APPROVED',
                value: $filter("translate")('Approved')
            },
            {
                key: 'REJECTED',
                value: $filter("translate")('Rejected')
            }
        ];

        self.EMPLOYEE_CONSENT_STATUSES = {
            'PENDING_EMPLOYEE_APPROVAL': {
                code: 'PENDING_EMPLOYEE_APPROVAL',
                label: $filter("translate")('Pending')
            },
            'APPROVED': {
                code: 'APPROVED',
                label: $filter("translate")('Approved')
            },
            'REJECTED': {
                code: 'REJECTED',
                label: $filter("translate")('Rejected')
            },
            'INVALID': {
                code: 'INVALID',
                label: '--'
            }
        };

        var init = function () {

            if (!self.startDayOfWeek) {
                console.error("Start day of week is not sent, given:", self.startDayOfWeek);
                self.loading = false;
                return;
            }

            loadFiltersData();
            loadPremiums();
        };

        var loadPremiums = function () {

            self.loading = true;

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    self.brand = brand;

                    fairSchedulingService.calculateSchedulePremiums(self.startDayOfWeek, self.filters)
                        .then(function (penaltiesList) {
                            self.currency = $filter("locationCurrencySymbol")(brand);
                            self.schedulePremiums = angular.copy(penaltiesList);
                            self.originalPremiums = angular.copy(penaltiesList);
                            var scheduleSettings = ScheduleDataServiceV2.getBrandScheduleSettings();
                            self.isEmployeeConsentFlowEnabled = scheduleSettings['fair_work_week_settings'] &&
                                                                scheduleSettings['fair_work_week_settings']['penalty_general_settings']&&
                                                                scheduleSettings['fair_work_week_settings']['penalty_general_settings']['employee_consent_flow_enabled'];
                            self.loading = false;
                            $scope.$digest();
                        })
                        .catch(function (err) {
                            console.error(err);
                        });
                });
        };

        self.applyFilters = function () {
            loadPremiums();
        };

        var loadFiltersData = function () {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    self.loadingUsers = true;

                    TSUsersService.getBrandTeamUsers(brand.id, true, 'ALL')
                        .then(function (users) {
                            self.allPositions = [];
                            self.categories = [];
                            self.employees = [];

                            for (var i in users) {
                                var user = angular.copy(users[i]);
                                user['name'] = [user['first_name'], user['last_name']].join(" ");

                                for (var i in user['positions']) {
                                    var position = angular.copy(user['positions'][i]);
                                    var category = angular.copy(position['category']);

                                    var positionIndex = self.allPositions.findIndex(function (item) {
                                        return item.id === position.id;
                                    });

                                    if (positionIndex === -1) {
                                        self.allPositions.push(position);
                                    }

                                    var categoryIndex = self.categories.findIndex(function (item) {
                                        return item.code === category.code;
                                    });

                                    if (categoryIndex === -1) {
                                        self.categories.push(category);
                                    }
                                }

                                self.employees.push(user);
                            }

                            updatePositionsList();

                            delete self.loadingUsers;
                            $scope.$digest();
                        });
                });
        };

        self.onCategoryChanged = function () {
            updatePositionsList();
            self.applyFilters();
        };

        self.enableEditMode = function (index) {
            self.schedulePremiums[index].isEditMode = true;
        };

        var disableEditMode = function (index) {
            self.schedulePremiums[index].isEditMode = false;
        };

        self.discard = function (index) {
            self.schedulePremiums[index] = angular.copy(self.originalPremiums[index]);
            disableEditMode(index);
        };

        var preparePremiumItemShift = function (shift, isRequestedByAssignee) {
            var shiftToSend = {
                start_time: shift && shift.start_time,
                end_time: shift && shift.end_time,
                role_id: shift && shift.role_id,
                assignee_id: shift && shift.assignee_id,
                schedule_id: ScheduleDataServiceV2.scheduleId,
                labels: [],
                code: shift && shift.code,
                weight: shift && shift.weight,
                breaks: shift && shift.breaks,
                incentive_payments: shift.incentive_payments,
                is_requested_by_assignee: isRequestedByAssignee
            };

            if (shift && shift.note) {
                shiftToSend['note'] = shift.note;
            }

            if (ScheduleDataServiceV2.shiftsTemplates && ScheduleDataServiceV2.shiftsTemplates[shift.code] && ScheduleDataServiceV2.shiftsTemplates[oldShift.code].id) {
                shiftToSend["template_id"] = ScheduleDataServiceV2.shiftsTemplates[shift.code].id;
            }

            if (shift && shift.revenue_center_id) {
                shiftToSend['revenue_center_id'] = shift.revenue_center_id;
            }

            if (shift && shift.label_id) {
                shiftToSend.labels.push(shift.label_id);
            }
            return shiftToSend;
        };

        self.updatePremiumItemConsent = function (index) {
            var premiumItem = self.schedulePremiums[index];
            var isRequestedByAssignee = premiumItem.isRequestedByAssignee && premiumItem.isRequestedByAssignee.key === 'YES' ? true : false;
            var updatedShift;
            var shiftToSend;
            var shiftId;

            if (premiumItem.toShift) {
                updatedShift = angular.copy(premiumItem.toShift);
                shiftToSend = preparePremiumItemShift(premiumItem.toShift, isRequestedByAssignee);
                shiftId = premiumItem.toShift.id;
            } else {
                updatedShift = angular.copy(premiumItem.fromShift);
                shiftToSend = preparePremiumItemShift(premiumItem.fromShift, isRequestedByAssignee);
                shiftId = premiumItem.fromShift.id;
            }

            premiumItem.savingEmployeeConsent = true ;

            TeamScheduleV2API.editShift(self.brand.id, ScheduleDataServiceV2.scheduleId, shiftId, shiftToSend)
                .then(function (res) {
                    onSave(updatedShift, res, loadPremiums);
                })
                .catch(function (err) {
                    console.error(err);
                    self.discard(index);

                    hAlert({
                        title: $filter("translate")("Something Went Wrong"),
                        text: $filter("translate")("Something went wrong please try again"),
                        custom_class: 'rejection-templates-error-alert',
                        button: {
                            text: $filter("translate")("Okay")
                        }
                    });
                })
                .finally(function () {
                    disableEditMode(index);
                    premiumItem.savingEmployeeConsent = false ;
                    $scope.$digest();
                });
        };

        var updatePositionsList = function () {
            if (self.filters['categories'] && self.filters['categories'].length > 0) {
                self.filters['positions'] = [];
                self.positions = [];

                for (var i in self.filters['categories']) {
                    var category = self.filters['categories'][i];

                    for (var j in self.allPositions) {
                        var position = self.allPositions[j];

                        if (position.category.code === category.code) {
                            self.positions.push(position);
                        }
                    }
                }
            }
            else {
                self.positions = self.allPositions;
            }
        };

        var getShiftFromUnPublishedTree = function (shiftId) {
            return ScheduleDataServiceV2.flatData['shifts'][shiftId];
        };

        self.revertPremiums = function (index) {
            var penaltyDetails = self.schedulePremiums[index];
            var updatedShift = angular.copy(penaltyDetails.toShift);
            var oldShift = angular.copy(penaltyDetails.fromShift);
            var promises = {};

            penaltyDetails.saving = true;

            if (penaltyDetails.fromShift) {
                var shiftId = oldShift.reference_id;

                if (!updatedShift) {
                    updatedShift = getShiftFromUnPublishedTree(shiftId);
                }

                if (updatedShift) {
                    if (updatedShift.status === 'DELETED') {
                        promises['restore'] = {};
                    } else {
                        var shiftToSend = {
                            start_time: oldShift.start_time,
                            end_time: oldShift.end_time,
                            role_id: updatedShift.role_id,
                            assignee_id: updatedShift.assignee_id,
                            schedule_id: ScheduleDataServiceV2.scheduleId,
                            labels: [],
                            code: oldShift.code,
                            weight: oldShift.weight,
                            breaks: oldShift.breaks
                        };

                        if (oldShift.note) {
                            shiftToSend['note'] = oldShift.note;
                        }

                        if (ScheduleDataServiceV2.shiftsTemplates && ScheduleDataServiceV2.shiftsTemplates[oldShift.code] && ScheduleDataServiceV2.shiftsTemplates[oldShift.code].id) {
                            shiftToSend["template_id"] = ScheduleDataServiceV2.shiftsTemplates[oldShift.code].id;
                        }

                        if (oldShift.revenue_center_id) {
                            shiftToSend['revenue_center_id'] = oldShift.revenue_center_id;
                        }

                        if (oldShift.label_id) {
                            shiftToSend.labels.push(oldShift.label_id);
                        }

                        if (oldShift.job_titles) {
                            shiftToSend['job_titles'] = oldShift.job_titles;
                        }

                        promises['edit'] = TeamScheduleV2API.editShift(self.brand.id, ScheduleDataServiceV2.scheduleId, shiftId, shiftToSend);
                    }

                } else {
                    console.error("Can't find the shift with id", shiftId);

                    hAlert({
                        title: $filter("translate")("Something Went Wrong"),
                        text: $filter("translate")("Something went wrong please try again"),
                        custom_class: 'rejection-templates-error-alert',
                        button: {
                            text: $filter("translate")("Okay")
                        }
                    });
                }

            } else {
                promises['delete'] = TeamScheduleAPI.deleteScheduleShift(ScheduleDataServiceV2.scheduleId, updatedShift.assignee_id, updatedShift.id);
            }

            $q.all(promises)
                .then(function (res) {
                    if (res['restore']) {
                        onRestore(updatedShift, loadPremiums);
                    } else if (res['delete']) {
                        onDelete(updatedShift, res['delete'], loadPremiums);
                    } else if (res['edit']) {
                        onSave(updatedShift, res['edit'], loadPremiums);
                    }
                })
                .catch(function (err) {
                    console.error(err);

                    hAlert({
                        title: $filter("translate")("Something Went Wrong"),
                        text: $filter("translate")("Something went wrong please try again"),
                        custom_class: 'rejection-templates-error-alert',
                        button: {
                            text: $filter("translate")("Okay")
                        }
                    });
                });
        };

        var getPremiumTypeText = function (premiumType) {
            var premiumTypeText;

            switch (premiumType) {
                case self.PREMIUM_TYPES.LENGTH_DECREMENT:
                    premiumTypeText = 'Subtracting Hours';
                    break;

                case self.PREMIUM_TYPES.LENGTH_INCREMENT:
                    premiumTypeText = 'Adding Hours';
                    break;

                case self.PREMIUM_TYPES.DATE_TIME_CHANGE:
                    premiumTypeText = 'Change Time';
                    break;

                case self.PREMIUM_TYPES.RIGHT_TO_REST:
                    premiumTypeText = 'Right to Rest';
                    break;
            }

            return premiumTypeText;
        };

        self.exportPenalties = function () {
            if (!self.loading && self.schedulePremiums.length) {
                var fileData = [];

                fileData.push([
                    'First Name',
                    'Last Name',
                    'Shift Date',
                    'From',
                    'To',
                    'Premium Type',
                    'Affected Hours',
                    'Penalty Amount',
                    'Penalty Status'
                ].join(","));

                for (var i in self.schedulePremiums) {
                    var penaltyItem = self.schedulePremiums[i];

                    fileData.push([
                        '"' + self.users[penaltyItem['user_id']]['first_name'] + '"',
                        '"' + self.users[penaltyItem['user_id']]['last_name'] + '"',
                        '"' + penaltyItem['date'] + '"',
                        '"' + (
                            penaltyItem['fromShift'] ?
                                ($filter('formatDate')(penaltyItem['fromShift'].start_time , 'h:mm a') + '-' + $filter('formatDate')(penaltyItem['fromShift'].end_time, 'h:mm a'))
                                : '--'
                        ) + '"',
                        '"' + (
                            penaltyItem['toShift'] && penaltyItem['toShift']['status'] !== 'DELETED' ?
                                ($filter('formatDate')(penaltyItem['toShift'].start_time, 'h:mm a') + '-' + $filter('formatDate')(penaltyItem['toShift'].end_time, 'h:mm a'))
                                : 'Deleted'
                        ) + '"',
                        '"' + getPremiumTypeText(penaltyItem['type']) + '"',
                        '"' + ((penaltyItem['type'] === self.PREMIUM_TYPES.LENGTH_INCREMENT || penaltyItem['type'] === self.PREMIUM_TYPES.LENGTH_DECREMENT) ? $filter('number')((penaltyItem['change_value'] / 3600), 2) : '--') + '"',
                        '"' + (penaltyItem.allow_access ? $filter('currency')(penaltyItem['penalty'], self.currency, 2) : '--') + '"',
                        '"' + (penaltyItem['status'] === 'published' ? 'Published' : 'Unpublished') + '"',
                    ].join(","));

                }

                Utils.downloadFileWithBOM(fileData.join("\n"), 'penalties.csv', "text/csv");
            }
        };

        self.close = function () {
            $scope.$hide();
        };

        self.premiumTypes = premiumTypes;

        init();
    }

    var premiumTypes = [
        { label: $filter('translate')('Change Time'), code: 'DATE_TIME_CHANGE' },
        { label: $filter('translate')('Adding Hours'), code: 'LENGTH_INCREMENT' },
        { label: $filter('translate')('Subtracting Hours'), code: 'LENGTH_DECREMENT' },
        { label: $filter('translate')('Right to Rest'), code: 'RIGHT_TO_REST' }
    ];
})();
